var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewcall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New_Call",
    "data-name": "New Call",
    transform: "translate(-8 -72)",
    opacity: 0.747
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2183",
    "data-name": "Rectangle 2183",
    width: 32,
    height: 32,
    transform: "translate(8 72)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone-call",
    "data-name": "Icon feather-phone-call",
    d: "M23,17.878V20.87a1.994,1.994,0,0,1-2.174,1.994A19.735,19.735,0,0,1,12.221,19.8,19.445,19.445,0,0,1,6.237,13.82,19.735,19.735,0,0,1,3.176,5.174,1.994,1.994,0,0,1,5.16,3H8.152a1.994,1.994,0,0,1,1.994,1.715,12.8,12.8,0,0,0,.7,2.8,1.994,1.994,0,0,1-.449,2.1L9.129,10.888a15.955,15.955,0,0,0,5.983,5.983L16.379,15.6a1.994,1.994,0,0,1,2.1-.449,12.8,12.8,0,0,0,2.8.7A1.994,1.994,0,0,1,23,17.878Z",
    transform: "translate(10.916 75.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-add-circle",
    "data-name": "Icon ionic-md-add-circle",
    d: "M8.343,3.375a4.968,4.968,0,1,0,4.968,4.968A4.968,4.968,0,0,0,8.343,3.375ZM10.9,8.845H8.845V10.9h-1V8.845H5.787v-1H7.842V5.787h1V7.842H10.9Z",
    transform: "translate(21.585 75.145)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewcall);
export default __webpack_public_path__ + "static/media/newcall.8c0278363452d79537dc7185739d63d3.svg";
export { ForwardRef as ReactComponent };